import React from 'react'
import {  Button, Input,  Form } from "antd";
import { updatePasswordApi } from '../../services/apiService'
import { showApiError, showApiSuccess } from "../utilities";

class ChangePasswordForm extends React.Component {

  state = {
    confirmDirty: false,
    autoCompleteResult: [],
  };


  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        //console.log('Received values of form: ', values);
        let data = {
          UserName: window.sessionStorage.getItem("UserName"),
          Password: values.current,
          NewPassword: values.password
        }

        //console.log(data)

        updatePasswordApi(data)
          .then(json => {
            if (typeof json === 'string') {
              throw new Error(json)
            } else {
              showApiSuccess("Password updated successfully!")
            }
          })
          .catch(error => {
            showApiError(error)
          })
      }
    });

  }

  handleConfirmBlur = e => {
    const { value } = e.target;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };

  compareToFirstPassword = (rule, value, callback) => {
    const { form } = this.props;
    if (value && value !== form.getFieldValue('password')) {
      callback('Two passwords that you enter is inconsistent!');
    } else {
      callback();
    }
  };

  validateToNextPassword = (rule, value, callback) => {
    const { form } = this.props;
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirm'], { force: true });
    }
    callback();
  };

  validateCurrentPassword = (rule, value, callback) => {
    callback();
  };


  render() {
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    }
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 4,
        },
      },
    };

    return (
      <div>

        <div className="panel" style={{ padding: 10 }}>
          <h4>Update Password</h4>
        </div>
        <Form {...formItemLayout} onSubmit={this.handleSubmit}>
          <Form.Item label="Currnet Password" hasFeedback>
            {getFieldDecorator('current', {
              rules: [
                {
                  required: true,
                  message: 'Please input your password!',
                },
                {
                  validator: this.validateCurrentPassword,
                },
              ],
            })(<Input.Password />)}
          </Form.Item>
          <Form.Item label="New Password" hasFeedback>
            {getFieldDecorator('password', {
              rules: [
                {
                  required: true,
                  message: 'Please input your password!',
                },
                {
                  validator: this.validateToNextPassword,
                },
              ],
            })(<Input.Password />)}
          </Form.Item>
          <Form.Item label="Confirm Password" hasFeedback>
            {getFieldDecorator('confirm', {
              rules: [
                {
                  required: true,
                  message: 'Please confirm your password!',
                },
                {
                  validator: this.compareToFirstPassword,
                },
              ],
            })(<Input.Password onBlur={this.handleConfirmBlur} />)}
          </Form.Item>
          <Form.Item {...tailFormItemLayout}>
            <Button type="primary" htmlType="submit">Update</Button>
          </Form.Item>
        </Form>
      </div>
    )
  } 
}

const WrappedChangePasswordForm = Form.create({ name: 'changePassword' })(ChangePasswordForm);
export default WrappedChangePasswordForm;